
<div class="val-flex-1" (keydown)="TraiterClavier($event)">
  <kendo-textbox #editeurTexte
                 (blur)="ChangerValeurFiltre()"
                 [(value)]="valeur">
  </kendo-textbox>
</div>
<button kendoButton
        class="val-bouton-effacer-filtre"
        [ngClass]="{'val-invisible': !boutonEffacerVisible}"
        [svgIcon]="boutonEffacerIcone"
        (click)="Effacer()">
</button>

